import { StyleSheet } from "react-native"
import { appColors, appFonts, fontSize } from "../../appTheme"

export const createVendorCreditsStyle = StyleSheet.create({
    containerView: { flex: 1 },
    headerView: {
        flexDirection: 'row', margin: 10, justifyContent: 'center', alignSelf: 'flex-end', marginBottom: 10
    },
    buttonContainerStyle: {
        marginHorizontal: 5
    },
    buttonStyle: {
        backgroundColor: appColors.primary, padding: 10, borderRadius: 7,
    },
    buttonTitleStyle: {
        color: appColors.light, fontSize: fontSize.smallHeaderFontSize,
    },
    outlineButtonTitleStyle: {
        color: appColors.primary, fontSize: fontSize.smallHeaderFontSize,
    },
    generalDetailsView: {
        marginHorizontal: 10, paddingLeft: 20, paddingTop: 10, backgroundColor: appColors.light, borderRadius: 16, marginBottom: 10
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
    },
    containerStyle: {
        height: 50, width: 90,
    },
    textStyle1: {
        textAlign: 'center', backgroundColor: appColors.lightBackgroundColor, borderBottomWidth: 1, borderColor: appColors.lightGrey, paddingHorizontal: 20, paddingVertical: 10,
    },
    clockInOutStyle: { borderWidth: 1, borderColor: appColors.lightGrey, borderRadius: 6, marginVertical: 5, flexDirection: 'row', justifyContent: 'space-between' },
    dateIconStyle: { marginHorizontal: 10, marginVertical: 8, },
    viewStyle: { flex: 0.5, marginRight: 20, },
    viewContainer: {
        flexDirection: 'row', marginVertical: 10,
    },
    productDetailsInputStyle: { justifyContent: 'center', alignItems: 'center', flex: 1 },
    productDetailInputViewStyle: { borderRightWidth: 1, borderColor: appColors.lightGrey, },
    dateIconContainer: { color: appColors.lightDark, padding: 10, },
    costSummaryInputViewStyle: { flexDirection: 'row', justifyContent: 'space-between' },
    modalContainer: { flex: 1, backgroundColor: appColors.transparentBackground, justifyContent: 'center', alignItems: 'center' }
})